<template>
  <div class="technologieberater">
    <v-row>
      <v-col>
        <h3>Technologieberater / Bearbeiter</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <b-select
          label="Anrede"
          type="text"
          v-model="technologieberater_anrede"
          :items="anredenListe"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Nachname"
          type="text"
          v-model="technologieberater_nachname"
        />
      </v-col>
      <v-col cols="4">
        <b-text-field
          label="Telefon"
          type="text"
          v-model="technologieberater_telefon"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-combobox
          class="pt-1"
          label="Titel"
          type="text"
          v-model="technologieberater_titel"
          :items="titelListe"
          hideDetails="auto"
          outlined
          dense
          @change="adaptTitle()"
        />
      </v-col>
      <v-col>
        <b-text-field
          label="Vorname"
          type="text"
          v-model="technologieberater_vorname"
        />
      </v-col>
      <v-col cols="4">
        <b-text-field
          label="Email"
          type="text"
          v-model="technologieberater_email"
          :rules="[validations.required, validations.emailValidation]"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import anreden from '@/utils/data/anreden';
import titel from '@/utils/data/titel';
import validations from '@/service/validations';

export default {
  name: 'Technologieberater',
  data() {
    return {
      titelListe: titel,
      anredenListe: anreden,
      validations: validations
    };
  },
  computed: {},
  mixins: [
    dataMixin(
      'technologieberater_anrede',
      'persistentData.projekt.technologieBerater.anrede'
    ),
    dataMixin(
      'technologieberater_nachname',
      'persistentData.projekt.technologieBerater.nachname'
    ),
    dataMixin(
      'technologieberater_telefon',
      'persistentData.projekt.technologieBerater.telefon'
    ),

    dataMixin(
      'technologieberater_titel',
      'persistentData.projekt.technologieBerater.titel'
    ),
    dataMixin(
      'technologieberater_vorname',
      'persistentData.projekt.technologieBerater.vorname'
    ),
    dataMixin(
      'technologieberater_email',
      'persistentData.projekt.technologieBerater.email'
    ),
  ],
  methods: {
    adaptTitle() {
      const title = this.technologieberater_titel;
      if (title.value) {
        this.technologieberater_titel = title.value;
      }
    }
  },
};
</script>

<style scoped>
</style>

